import React, { useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { BsCheckCircleFill } from "react-icons/bs";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  acknowledgeOnBoardingPolicy,
  getOnboardingPolicies,
} from "../../../services/onBoardingServices";
import { useLocation, useParams } from "react-router-dom";
import FilePreviewer from "../../../components/FilePreviewer";
import Swal from "sweetalert2";
import { decrypt } from "../../../utils/crypto";

const OnboardingPolicyAcknowledgment = () => {
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const { t } = useTranslation();
  const location = useLocation();
  const loginEmployee = localStorage.getItem("employeeID");
  const stepData = location?.state?.step;
  const mode = location?.state?.action ?? "review";
  const [checkedPolicies, setCheckedPolicies] = useState({});
  const [onboardingPolicies, setOnboardingPolicies] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleCheckboxChange = (id) => {
    setCheckedPolicies((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const fetchOnboardingPolicies = async (id) => {
    try {
      const result = await getOnboardingPolicies(id);
      if (result?.onboardingPolicies?.length > 0) {
        setOnboardingPolicies(result?.onboardingPolicies);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAcknowledge = async (policyInfo) => {
    const data = {
      employeeId: employee_id,
      policyId: policyInfo?.company_policy_id,
      policyVersionId: policyInfo?.policy_version_id,
      step: stepData?.stepId,
    };
    setLoader(true);
    try {
      const result = await acknowledgeOnBoardingPolicy(data);
      if (result?.success == true) {
        await fetchOnboardingPolicies(employee_id);
        Swal.fire({
          title: "Policy",
          text: "Policy acknowledged successfully",
          icon: "success",
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Policy",
        text: "Something went wrong",
        icone: "warning",
        timer: 1500,
      });
    } finally {
      setLoader(false);
    }
    // }
  };

  useEffect(() => {
    if (employee_id) {
      fetchOnboardingPolicies(employee_id);
    }
  }, []);

  return (
    <div className="page-wrapper">
      {/* Page Content */}
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t("Acknowledge Policies")}
          title={t("Onboarding")}
          subtitle={t("Policies")}
        />

        <Accordion defaultActiveKey="">
          {onboardingPolicies.map((policy, index) => {
            const color =
              policy.acknowledgment_status === "ACKNOWLEDGED"
                ? "success"
                : "warning";
            return (
              <Accordion.Item
                eventKey={index.toString()}
                key={policy.policy_onboarding_config_id}
              >
                <Accordion.Header>
                  <div className="w-100 me-2">
                    <div className="d-flex justify-content-between gap-2">
                      <p className="mb-0">{policy.policy_name}</p>
                      <span className={`badge badge-${color}`}>
                        {policy.acknowledgment_status ?? "PENDING"}
                      </span>
                    </div>

                    <p className="small text-muted">
                      {policy.policy_description}
                    </p>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <FilePreviewer fileSource={policy.policy_file} />

                  {!(policy.acknowledgment_status === "ACKNOWLEDGED") &&
                    mode === "upload" && (
                      <div className="mt-4">
                        <Form.Check
                          type="checkbox"
                          id={`check-${policy.company_policy_id}`}
                          label="I have read and acknowledge this policy."
                          checked={!!checkedPolicies[policy.company_policy_id]}
                          onChange={() =>
                            handleCheckboxChange(policy.company_policy_id)
                          }
                        />
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            className="mt-3"
                            onClick={() => handleAcknowledge(policy)}
                            disabled={
                              !checkedPolicies[policy.company_policy_id] ||
                              loader
                            }
                          >
                            {loader ? "Acknowledging..." : "Acknowledge"}
                          </Button>
                        </div>
                      </div>
                    )}
                  {policy.acknowledgment_status === "ACKNOWLEDGED" && (
                    <div className="mt-4 text-success d-flex align-items-center gap-2 justify-content-center">
                      <BsCheckCircleFill /> Acknowledged
                    </div>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default OnboardingPolicyAcknowledgment;
